/** @jsxImportSource @emotion/react */
import React from 'react';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import Text from 'ud-ui/components/text';
import * as S from './styles';

export interface IValueProps extends DivProps {
  value?: string;
  label?: string;
}

function Value(props: IValueProps) {
  const { value, label, ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      <Text variant="title-1" color={theme.colors.DarkBlue}>
        {value}
      </Text>
      <Text variant="subtitle-2" color={theme.colors.WhiteGray}>
        {label}
      </Text>
    </S.MainBlock>
  );
}

export default Value;
